import type { IObservableArray } from 'mobx'
import { makeObservable, observable } from 'mobx'

import BaseFormCollection from 'modules/reports/lib/Store/FormCollections/Base'
// This is an array of conditions
import type { FilterParams } from 'modules/reports/store/models/Filter'

import FilterForm from './Form'

// This filters should be conditions
interface Props {
  filters: FilterParams[]
}

class FiltersFormCollection<T extends FilterForm> extends BaseFormCollection<T> {
  filters: IObservableArray<FilterParams>

  constructor(props: Props) {
    super()
    makeObservable(this, {
      filters: observable,
    })

    const { filters } = props
    this.filters = filters as IObservableArray<FilterParams>
    this.forms = FilterForm.buildForms(this.filters) as IObservableArray<T>
  }

  addForm(form: FilterForm) {
    this.forms.push(form as any)
  }

  paths(): Array<string> {
    return (
      this.forms.flatMap((form) =>
        form.conditions?.selectedFieldTypes.flatMap((x) => x.field.attributes.path)
      ) || []
    )
  }

  convertToParams(): FilterParams[] {
    return FilterForm.convertToParams(this.forms)
  }
}

export default FiltersFormCollection
